// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit {
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active)  {

  [type='checkbox']:checked {
    appearance: auto;
  }
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active)  {

  [type='radio']:checked {
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active)  {

  [type='checkbox']:indeterminate {
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}
  html {
  height: 100vh;
  width: 100vw;
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
  body {
  height: 100%;
  width: 100%;
}
  label {
  border-style: none;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  --tw-text-opacity: 1;
  color: rgb(65 69 71 / var(--tw-text-opacity, 1));
}
  input {
  display: flex;
  height: 58px;
  width: 100%;
  align-items: flex-start;
  border-radius: 8px;
  border-style: none;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 14px;
  padding-bottom: 14px;
  --tw-text-opacity: 1;
  color: rgb(65 69 71 / var(--tw-text-opacity, 1));
}
  input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(44 46 48 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 48px;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
  form {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
  h1 {
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
}
  @media (min-width: 1024px) {

  h1 {
    font-size: 40px;
    font-weight: 325;
    line-height: 48px;
  }
}
  h2 {
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
}
  @media (min-width: 1024px) {

  h2 {
    font-size: 28px;
    line-height: 36px;
  }
}
  h3 {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}
  @media (min-width: 1024px) {

  h3 {
    font-size: 24px;
    line-height: 32px;
  }
}
  h4 {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
  h5 {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
  h6 {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.form-input,.form-textarea,.form-select,.form-multiselect {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}
.form-input:focus, .form-textarea:focus, .form-select:focus, .form-multiselect:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
.form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}
.form-select:where([size]:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}
#root {
  display: flex;
  height: 100%;
  width: 100%;
}
.btn-primary {
  display: flex;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(43 128 0 / var(--tw-bg-opacity, 1));
  text-align: center;
  color: hsla(0, 0%, 100%, 1);
}
.btn-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 92 9 / var(--tw-bg-opacity, 1));
}
.btn-primary:focus {
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(43 128 0 / var(--tw-border-opacity, 1));
  --tw-shadow: 0 0 0 3px #2B8000;
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-primary:active {
  --tw-bg-opacity: 1;
  background-color: rgb(22 62 6 / var(--tw-bg-opacity, 1));
}
.btn-primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(103 110 115 / var(--tw-bg-opacity, 1));
}
.btn-secondary {
  display: flex;
  width: 100%;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(43 128 0 / var(--tw-border-opacity, 1));
  text-align: center;
  --tw-text-opacity: 1;
  color: rgb(43 128 0 / var(--tw-text-opacity, 1));
}
.btn-secondary:disabled {
  border-style: none;
}
.menu-item {
  display: flex;
  width: 100%;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.menu-item2 {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tracking-input {
  box-sizing: border-box;
  display: flex;
  height: 3rem;
  flex-direction: row;
  align-items: flex-start;
  border-radius: 4px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(103 110 115 / var(--tw-border-opacity, 1));
  background-color: hsla(0, 0%, 100%, 1);
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0.75rem;
  padding-right: 2.5rem;
}
.tracking-input:focus {
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgb(124 83 165 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.breadcrumbs {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  --tw-text-opacity: 1;
  color: rgb(103 110 115 / var(--tw-text-opacity, 1));
}
.fb-invalid {
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  --tw-text-opacity: 1;
  color: rgb(225 35 57 / var(--tw-text-opacity, 1));
}
.sp-d {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  --tw-text-opacity: 1;
  color: rgb(103 110 115 / var(--tw-text-opacity, 1));
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.right-4 {
  right: 1rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-\\[10px\\] {
  top: 10px;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mt-20 {
  margin-top: -5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-\\[6px\\] {
  margin-top: 6px;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-14 {
  height: 3.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[326px\\] {
  height: 326px;
}
.h-full {
  height: 100%;
}
.max-h-96 {
  max-height: 24rem;
}
.w-11 {
  width: 2.75rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\/4 {
  width: 50%;
}
.w-32 {
  width: 8rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.max-w-96 {
  max-width: 24rem;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-grow-0 {
  flex-grow: 0;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-around {
  justify-content: space-around;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.self-stretch {
  align-self: stretch;
}
.overflow-hidden {
  overflow: hidden;
}
.rounded {
  border-radius: 8px;
}
.rounded-button {
  border-radius: 48px;
}
.rounded-full {
  border-radius: 100%;
}
.rounded-small {
  border-radius: 4px;
}
.border {
  border-width: 1px;
}
.border-error {
  border-color: hsla(0, 100%, 50%, 1);
}
.border-greyShuttle {
  --tw-border-opacity: 1;
  border-color: rgb(103 110 115 / var(--tw-border-opacity, 1));
}
.border-lightText {
  --tw-border-opacity: 1;
  border-color: rgb(16 16 16 / var(--tw-border-opacity, 1));
}
.bg-completed {
  background-color: hsla(327, 46%, 48%, 1);
}
.bg-greyAthens {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 247 / var(--tw-bg-opacity, 1));
}
.bg-white {
  background-color: hsla(0, 0%, 100%, 1);
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-7 {
  padding: 1.75rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.text-center {
  text-align: center;
}
.text-px12 {
  font-size: 12px;
}
.text-px16 {
  font-size: 16px;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.italic {
  font-style: italic;
}
.leading-px16 {
  line-height: 16px;
}
.tracking-input {
  letter-spacing: -0.011em;
}
.text-confirm {
  color: hsla(148, 79%, 38%, 1);
}
.text-error {
  color: hsla(0, 100%, 50%, 1);
}
.text-greenAccessible {
  --tw-text-opacity: 1;
  color: rgb(43 128 0 / var(--tw-text-opacity, 1));
}
.text-greyShuttle {
  --tw-text-opacity: 1;
  color: rgb(103 110 115 / var(--tw-text-opacity, 1));
}
.text-greyThunder {
  --tw-text-opacity: 1;
  color: rgb(44 46 48 / var(--tw-text-opacity, 1));
}
.text-purpleTelus {
  --tw-text-opacity: 1;
  color: rgb(124 83 165 / var(--tw-text-opacity, 1));
}
.text-red {
  --tw-text-opacity: 1;
  color: rgb(225 35 57 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.shadow-elevation1 {
  --tw-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0px 4px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.visible {
  opacity: 1;
  transition: all 1s ease-out;
  visibility: visible;
}

.hide {
  visibility: hidden;
  transition: all 1s ease-out;
  opacity: 0;
}

.border-grey-200 {
  border-bottom: 0.5px solid #e2e2e2;
}
.border-grey-200:hover {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.5);
}

.border-greyDark-200 {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}

.border-greyDark-200:hover {
  border: 1px solid rgba(0, 0, 0, 0.5);
}

.text-2xl {
  font-size: 1.5rem;
}

.font-semibold {
  font-weight: 600;
}

.spinner {
  animation: spinner 1.5s linear infinite;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tracking-input {
  border: 1px solid #676e73;
}

.tracking-input:focus {
  border: 3px solid #7c53a5;
  --tw-ring-color: none !important;
}

.tracking-input-error {
  border: 1px solid #e12339;
}

.tracking-input-success {
  border: 1px solid #2b8000;
}

.pin-input:focus {
  --tw-ring-color: transparent !important;
}

.pin-drop-shadow {
  filter: drop-shadow(0px 0px 1px hsla(137, 28%, 46%, 1));
}

.pin-border {
  border-radius: 4px !important;
}
.bg-completed {
  background: linear-gradient(108.43deg, #e53293 -11.22%, #4b286d 75.01%);
  border-radius: 4px;
}

body > iframe {
  display: none;
}

@media (min-width: 1024px) {

  .lg\\:w-11 {
    width: 2.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;EAAd;EAAA,aAAc;EAAd,YAAc;EAAd,wBAAc;EAAd,0BAAc;EAAd;AAAc;EAAd;EAAA,YAAc;EAAd;AAAc;EAAd;EAAA,kBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd;AAAc;EAAd;EAAA,aAAc;EAAd,YAAc;EAAd,WAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd,kBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd;AAAc;EAAd;EAAA,sBAAc;EAAd,yDAAc;EAAd,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;EAAd;EAAA,aAAc;EAAd,WAAc;EAAd,mBAAc;EAAd,uBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,kBAAc;EAAd,eAAc;EAAd;AAAc;EAAd;EAAA,kBAAc;EAAd,aAAc;EAAd,YAAc;EAAd,sBAAc;EAAd;AAAc;EAAd;EAAA,eAAc;EAAd,gBAAc;EAAd;AAAc;EAAd;;EAAA;IAAA,eAAc;IAAd,gBAAc;IAAd;EAAc;AAAA;EAAd;EAAA,eAAc;EAAd,gBAAc;EAAd;AAAc;EAAd;;EAAA;IAAA,eAAc;IAAd;EAAc;AAAA;EAAd;EAAA,eAAc;EAAd,gBAAc;EAAd;AAAc;EAAd;;EAAA;IAAA,eAAc;IAAd;EAAc;AAAA;EAAd;EAAA,eAAc;EAAd,gBAAc;EAAd;AAAc;EAAd;EAAA,eAAc;EAAd,gBAAc;EAAd;AAAc;EAAd;EAAA,eAAc;EAAd,gBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAoB;EAApB;AAAoB;AAApB;EAAA,yDAAoB;EAApB,wCAAoB;EAApB,4BAAoB;EAApB,4BAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AA4ChB;EAAA,aAAyB;EAAzB,YAAyB;EAAzB;AAAyB;AAGzB;EAAA,aAAkM;EAAlM,WAAkM;EAAlM,kBAAkM;EAAlM,yDAAkM;EAAlM,kBAAkM;EAAlM;AAAkM;AAAlM;EAAA,kBAAkM;EAAlM;AAAkM;AAAlM;EAAA,iBAAkM;EAAlM,sBAAkM;EAAlM,yDAAkM;EAAlM,8BAAkM;EAAlM,qDAAkM;EAAlM;AAAkM;AAAlM;EAAA,kBAAkM;EAAlM;AAAkM;AAAlM;EAAA,kBAAkM;EAAlM;AAAkM;AAGlM;EAAA,aAAuG;EAAvG,WAAuG;EAAvG,iBAAuG;EAAvG,sBAAuG;EAAvG,yDAAuG;EAAvG,kBAAuG;EAAvG,oBAAuG;EAAvG;AAAuG;AAAvG;EAAA;AAAuG;AAqBvG;EAAA,aAA4E;EAA5E,WAA4E;EAA5E,eAA4E;EAA5E,mBAA4E;EAA5E,mBAA4E;EAA5E,8BAA4E;EAA5E,mBAA4E;EAA5E;AAA4E;AAG5E;EAAA,aAA6D;EAA7D,WAA6D;EAA7D,mBAA6D;EAA7D,mBAA6D;EAA7D,8BAA6D;EAA7D,mBAA6D;EAA7D;AAA6D;AAS7D;EAAA,sBAA6L;EAA7L,aAA6L;EAA7L,YAA6L;EAA7L,mBAA6L;EAA7L,uBAA6L;EAA7L,kBAA6L;EAA7L,iBAA6L;EAA7L,sBAA6L;EAA7L,4DAA6L;EAA7L,sCAA6L;EAA7L,gBAA6L;EAA7L,mBAA6L;EAA7L,qBAA6L;EAA7L;AAA6L;AAA7L;EAAA,iBAA6L;EAA7L,sBAA6L;EAA7L,2DAA6L;EAA7L,8BAA6L;EAA7L,mBAA6L;EAA7L,2GAA6L;EAA7L,yGAA6L;EAA7L;AAA6L;AAY7L;EAAA,eAA0D;EAA1D,gBAA0D;EAA1D,iBAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;AAkB1D;EAAA,kBAAsD;EAAtD,eAAsD;EAAtD,iBAAsD;EAAtD,oBAAsD;EAAtD;AAAsD;AA8BtD;EAAA,kBAA0D;EAA1D,eAA0D;EAA1D,iBAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;AA9I9D;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AA+JnB;EACE,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,uCAAuC;AACzC;;AAWA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AA/PA;;EAAA;IAAA;EAgQA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  html {\n    @apply transition-all duration-300 ease-in-out  w-screen h-screen;\n  }\n  body {\n    @apply w-full h-full;\n  }\n  label {\n    @apply font-bold text-px16 leading-px24 text-greyCharcoal border-none;\n  }\n  input {\n    @apply flex rounded items-start h-[58px] w-full px-4 py-[14px]  focus:outline-none focus:ring-0  focus:border-greyThunder border-none text-greyCharcoal;\n  }\n  button {\n    @apply flex justify-center w-full rounded-button py-3 px-8 text-center items-center font-bold text-px16;\n  }\n  form {\n    @apply flex flex-col justify-between h-full relative;\n  }\n  h1 {\n    @apply text-px28 lg:text-px40 leading-px36 lg:leading-px48 font-regular lg:font-light;\n  }\n  h2 {\n    @apply text-px24 lg:text-px28 leading-px32 lg:leading-px36 font-regular;\n  }\n  h3 {\n    @apply text-px20 lg:text-px24 leading-px28 lg:leading-px32 font-medium;\n  }\n  h4 {\n    @apply text-px16 leading-px24 font-medium;\n  }\n  h5 {\n    @apply text-px14 leading-px18 font-medium;\n  }\n  h6 {\n    @apply text-px12 leading-px16 font-bold;\n  }\n}\n\n@layer components {\n  #root {\n    @apply w-full h-full flex;\n  }\n  .btn-primary {\n    @apply bg-greenAccessible hover:bg-greenSanFelix active:bg-greenDarkFern focus:shadow-ring focus:border-greenAccessible focus:border-2  flex w-full text-white text-center disabled:bg-greyShuttle;\n  }\n  .btn-secondary {\n    @apply border border-greenAccessible text-greenAccessible  flex w-full text-center disabled:border-none;\n  }\n  .btn-step {\n    @apply w-3 h-3 rounded-full bg-greyShuttle p-0;\n  }\n  .btn-back {\n    @apply bg-greenAccessible/0 hover:bg-greenSanFelix/0 active:bg-greenDarkFern/0 focus:shadow-ring mt-2 focus:border-greenAccessible focus:border-2  flex w-full text-greyThunder text-center disabled:bg-greyShuttle;\n  }\n  .btn-ctp {\n    @apply text-px16 leading-px24 text-greyCharcoal;\n  }\n  .twcheckbox {\n    @apply w-6 h-6 text-greenAccessible  bg-greyShuttle rounded-small border border-greyShuttle focus:ring-0 checked:bg-greenAccessible;\n  }\n  .fr-message {\n    @apply font-regular text-greyThunder;\n  }\n  .tracking-passProt {\n    @apply focus:outline-none focus:ring-0 focus:border-greyThunder rounded-small border-none;\n  }\n  .menu-item {\n    @apply flex flex-row justify-between items-center w-full py-2 cursor-pointer;\n  }\n  .menu-item2 {\n    @apply flex flex-row justify-between items-center w-full py-2;\n  }\n  .text-display1 {\n    @apply text-px40 lg:text-px64 leading-px48 lg:leading-px72 font-light;\n  }\n  .text-display2 {\n    @apply text-px36 lg:text-px56 leading-px44 lg:leading-px64 font-regular lg:font-light;\n  }\n  .tracking-input {\n    @apply h-12 flex flex-row items-start py-0 pl-3 pr-10 box-border bg-white border border-greyShuttle rounded-small focus:outline-none focus:ring-0 focus:border-[3px] focus:border-purpleTelus;\n  }\n  .form-check-input {\n    @apply form-input bg-white border rounded-small m-5 border-greyShuttle ring-1 ring-greyShuttle checked:text-greenAccessible p-[10px];\n  }\n  .text-link {\n    @apply underline cursor-pointer font-bold text-modal;\n  }\n  .text-open___modal {\n    @apply underline cursor-pointer font-bold  text-modal;\n  }\n  .breadcrumbs {\n    @apply text-px12 leading-px16 text-greyShuttle font-medium;\n  }\n  .stepper {\n    @apply text-px16 leading-px24 text-greyThunder font-regular;\n  }\n  .fp-title {\n    @apply text-px28  leading-px36  font-regular text-purpleTelus;\n  }\n  .fp-description {\n    @apply text-px16  leading-px24  font-regular text-greyThunder;\n  }\n  .fb {\n    @apply text-greyThunder text-px16 leading-px24 text-center underline;\n  }\n  .fb-valid {\n    @apply text-greenAccessible text-px16 leading-px24 text-center;\n  }\n  .fb-invalid {\n    @apply text-redDark text-px16 leading-px24 text-center;\n  }\n  .dp-t {\n    @apply text-px24 leading-px32 text-center;\n  }\n  .dp-ct {\n    @apply font-bold text-px14 leading-px20 text-greyThunder;\n  }\n  .dp-cv {\n    @apply font-regular text-px14 leading-px20 text-greyCharcoal;\n  }\n  .ep-t {\n    @apply text-center text-px16 leading-px24 text-purpleTelus;\n  }\n  .ep-s {\n    @apply text-center text-px20 leading-px28 text-purpleTelus font-medium;\n  }\n  .ep-d {\n    @apply text-center text-px14 leading-px20 text-greyShuttle;\n  }\n  .ep-bs {\n    @apply text-center text-px14 leading-px20 text-greyShuttle;\n  }\n  .ep-bn {\n    @apply text-center text-px14 leading-px20 text-purpleTelus font-bold;\n  }\n  .sp-t {\n    @apply text-px20 leading-px28 font-medium text-center text-purpleTelus;\n  }\n  .sp-d {\n    @apply text-px14 leading-px20 text-center text-greyShuttle;\n  }\n  .sp-i- {\n    @apply text-px14 leading-px20 text-center text-greyThunder;\n  }\n  .sp-i-o {\n    @apply text-px14 leading-px20 text-center text-greyThunder underline font-bold;\n  }\n  .sp-o {\n    @apply text-px12 leading-px16 text-center text-greyThunder underline font-medium;\n  }\n\n  .tst-t {\n    @apply text-white text-center text-px14 leading-px20;\n  }\n}\n\n.visible {\n  opacity: 1;\n  transition: all 1s ease-out;\n  visibility: visible;\n}\n\n.hide {\n  visibility: hidden;\n  transition: all 1s ease-out;\n  opacity: 0;\n}\n\n.border-grey-200 {\n  border-bottom: 0.5px solid #e2e2e2;\n}\n.border-grey-200:hover {\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.5);\n}\n\n.border-greyDark-200 {\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n}\n\n.border-greyDark-200:hover {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.spinner {\n  -webkit-animation: spinner 1.5s linear infinite;\n  animation: spinner 1.5s linear infinite;\n}\n\n@-webkit-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.tracking-input {\n  border: 1px solid #676e73;\n}\n\n.tracking-input:focus {\n  border: 3px solid #7c53a5;\n  --tw-ring-color: none !important;\n}\n\n.tracking-input-error {\n  border: 1px solid #e12339;\n}\n\n.tracking-input-success {\n  border: 1px solid #2b8000;\n}\n\n.pin-input:focus {\n  --tw-ring-color: transparent !important;\n}\n\n.pin-drop-shadow {\n  filter: drop-shadow(0px 0px 1px hsla(137, 28%, 46%, 1));\n}\n\n.pin-border {\n  border-radius: 4px !important;\n}\n.bg-completed {\n  background: linear-gradient(108.43deg, #e53293 -11.22%, #4b286d 75.01%);\n  border-radius: 4px;\n}\n\nbody > iframe {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
